import React from "react";
import cancel from "../../Assets/Images/cancel.svg";
import "../../Assets/Styles/pages/cancel_button.scss";

interface CancelButtonProps {
  close: () => void;
}

const CancelButton: React.FC<CancelButtonProps> = ({ close }) => {
  return (
    <div className="cancel_button d-flex justify-content-end">
      <img alt="Cancel Button" src={cancel} onClick={close} role="button" />
    </div>
  );
};
export default CancelButton;
